const i18n = window.axamitFormI18n || {}

// inputs
const userNameInput = document.querySelector('#userName')
const userPhoneInput = document.querySelector('#userPhone')
const userEmailInput = document.querySelector('#userEmail')
const companyInput = document.querySelector('#company')
const userMessageInput = document.querySelector('#userMessage')
const policyCheckbox = document.querySelector('#policy')

// btns
const letsTalkBtns = $('.contact-box-form-btn')
const cardMailBtn = $('.card__email')

// errors
const userNameError = document.querySelector('#userNameError')
const userPhoneError = document.querySelector('#userPhoneError')
const userEmailError = document.querySelector('#userEmailError')
const companyError = document.querySelector('#companyError')
const termsError = document.querySelector('#termsError')
let isFormSent = false
const maxCharacters = 16
const emailReg = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,63}$/)

const formValues = {
    userName: '',
    userPhone: '',
    userEmail: '',
    company: '',
    userMessage: '',
    terms: false,
}

const formErrors = {
    userName: '',
    userPhone: '',
    userEmail: '',
    company: '',
    userMessage: '',
    terms: '',
}

cardMailBtn.on('click', function () {
    const temp = $("<input>");
    $("body").append(temp);
    temp.val($(this).data('email')).select();
    document.execCommand("copy");
    temp.remove();
})

userNameInput.addEventListener('blur', function () {
    formValues.userName = this.value
})

userPhoneInput.addEventListener('input', function () {
    let inputValue = this.value.replace(/\D/g, '')

    if (!inputValue.startsWith('+')) {
        inputValue = '+' + inputValue
    }

    if (inputValue.length > maxCharacters) {
        inputValue = inputValue.substring(0, maxCharacters)
    }

    this.value = inputValue
})

userPhoneInput.addEventListener('blur', function () {
    this.value = this.value.replace(/\s/g, '')

    formValues.userPhone = this.value
})

userEmailInput.addEventListener('blur', function () {
    this.value = this.value.replace(/\s/g, '')

    formValues.userEmail = this.value
})

companyInput.addEventListener('blur', function () {

    formValues.company = this.value
})

userMessageInput.addEventListener('blur', function () {

    formValues.userMessage = this.value
})

policyCheckbox.addEventListener('change', (e) => {
    formValues.terms = e.target.checked
})

letsTalkBtns.on('click', (e) => {
    if (!isFormValid() || isFormSent) {
        e.preventDefault()
        return
    }
    isFormSent = true
})

function isFormValid() {
    userNameValidate()
    userPhoneValidate()
    userEmailValidate()
    companyValidate()
    termsValidate()

    return !formErrors.userName && !formErrors.userPhone && !formErrors.userEmail &&
        !formErrors.company && !formErrors.terms
}

function userNameValidate() {
    const value = formValues.userName

    if (!value) {
        formErrors.userName = i18n.enterYourName || 'Enter your name, please.'
    } else if (value.length > 256) {
        formErrors.userName = i18n.nameTooLong || 'Name cannot be longer than 256 symbols.'
    } else {
        formErrors.userName = ''
    }

    handleErrorVisibility(userNameError, userNameInput, formErrors.userName)
}

function userPhoneValidate() {
    const value = formValues.userPhone

    if (!value) {
        formErrors.userPhone = i18n.enterYourPhone || 'Enter your phone number.'
    } else {
        formErrors.userPhone = ''
    }

    handleErrorVisibility(userPhoneError, userPhoneInput, formErrors.userPhone)
}

function userEmailValidate() {
    const value = formValues.userEmail

    if (!value) {
        formErrors.userEmail = i18n.enterYourEmail || 'Enter your email address.'
    } else if (!emailReg.test(value)) {
        formErrors.userEmail = i18n.enterValidEmail || 'Enter a valid email address.'
    } else {
        formErrors.userEmail = ''
    }

    handleErrorVisibility(userEmailError, userEmailInput, formErrors.userEmail)
}

function companyValidate() {
    const value = formValues.company

    if (!value) {
        formErrors.company = i18n.enterYourCompany || 'Enter your company name.'
    } else {
        formErrors.company = ''
    }

    handleErrorVisibility(companyError, companyInput, formErrors.company)
}

function termsValidate() {
    const value = formValues.terms

    if (!value) {
        formErrors.terms = i18n.checkBoxToProceed || 'Check the box to proceed.'
    } else {
        formErrors.terms = ''
    }

    handleErrorVisibility(termsError, policyCheckbox, formErrors.terms)
}

function handleErrorVisibility(errorInput, formField, errorMessage) {
    errorInput.textContent = errorMessage

    if (errorMessage) {
        errorInput.classList.add('show')
        formField.classList.add('error-input')
    } else {
        errorInput.classList.remove('show')
        formField.classList.remove('error-input')
    }
}

function updateCheckboxAttributes() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    const mainFormLeft = document.getElementById('heroForm')

    if (mainFormLeft) {
        const checkbox = mainFormLeft.querySelector('#policy')
        const checkboxLabel = mainFormLeft.querySelector('label[for="policy"]')

        if (screenWidth <= 768) {
            checkbox.id = 'off'
            checkboxLabel.setAttribute('for', 'off')
        } else {
            checkbox.id = 'policy'
            checkboxLabel.setAttribute('for', 'policy')
        }
    }
}

window.addEventListener('load', updateCheckboxAttributes)
window.addEventListener('resize', updateCheckboxAttributes)
